import React from "react";
import "./Button.css";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: "green" | "outlined-green" | "red" | "outlined-red";
    style?: React.CSSProperties;
}

const Button: React.FC<ButtonProps> = ({
    variant,
    className = "",
    children,
    style,
    ...props
}) => {
    const variantClass = variant ? `btn-${variant}` : "btn-default"; // Defaults to basic button

    return (
        <button
            style={style}
            className={`btn ${variantClass} ${className}`}
            {...props}
        >
            {children}
        </button>
    );
};

export default Button;
